import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Navbar from "./components/Navbar";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Community from "./pages/Community";
import PostDetail from "./pages/PostDetail";
import AdminPanel from "./pages/AdminPanel";
import UserProfile from "./pages/UserProfile";
import { Toaster } from "./components/ui/sonner";
import Footer from "./components/Footer";

const Home = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="flex-1 flex items-center justify-center py-12">
        <div className="text-center max-w-4xl mx-auto px-4">
          <div className="mb-8">
            <img 
              src="https://i0.wp.com/periwinkle-labs.com/wp-content/uploads/2025/10/yellow-minimalist-world-smile-day-instagram-post-1-e1766753158415.png" 
              alt="Iniraa Logo" 
              className="h-24 w-auto mx-auto mb-6"
            />
          </div>
          <h1 className="text-5xl font-bold mb-4">
            <span className="text-[#7B3F9E]">Welcome to </span>
            <span className="text-[#FF8C00]">MyIniraa</span>
          </h1>
          <p className="text-xl text-gray-700 mb-8">
            A supportive community for women's pelvic health
          </p>
          <div className="space-x-4">
            <a
              href="/myiniraa"
              className="inline-block bg-[#FF8C00] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[#E67E00] transition shadow-lg"
            >
              Join Community
            </a>
            <a
              href="https://periwinkle-labs.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#7B3F9E] text-white px-8 py-3 rounded-lg font-semibold hover:bg-[#6A3586] transition shadow-lg"
            >
              Learn About Iniraa
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/myiniraa" element={<Community />} />
            <Route path="/myiniraa/post/:postId" element={<PostDetail />} />
            <Route path="/myiniraa/admin" element={<AdminPanel />} />
            <Route path="/profile" element={<UserProfile />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
